// removed by extract-text-webpack-plugin
module.exports = {"Loading":"Loading--2qD7i","Display":"Display--3O14o"};